import { createAsyncThunk } from "@reduxjs/toolkit";

import { loadDeploymentCurrentImagesRequest } from "Api/organizations/projects/environments/deployments/loadDeploymentCurrentImages.request";
import logger from "Libs/logger";
import { getProjectId } from "Libs/utils";
import { getCommonError } from "Reducers/sliceFactory";

import type { AsyncThunkOptionType } from "Reducers/types";
import type {
  LoadDeploymentCurrentImagesProps,
  LoadDeploymentCurrentImagesPayload
} from "../types";

export const loadDeploymentCurrentImages = createAsyncThunk<
  LoadDeploymentCurrentImagesPayload,
  LoadDeploymentCurrentImagesProps,
  AsyncThunkOptionType
>(
  "app/environmentDeployment/current/images",
  async ({ projectId, environmentId }, { getState, rejectWithValue }) => {
    try {
      const projectDescriptionId = getProjectId(getState, projectId)!;
      const images = await loadDeploymentCurrentImagesRequest({
        projectId: projectDescriptionId,
        environmentId
      });

      return images;
    } catch (error) {
      if (![404, 403].includes((error as { code: number }).code)) {
        const commonError = getCommonError(error).error;
        const errorMessage =
          commonError?.message ??
          "An error occurred while attempting to load deployment.";

        logger(errorMessage, {
          action: "load_deployment_current",
          meta: {
            environmentDescriptionId: environmentId,
            projectDescriptionId: projectId
          }
        });
      }

      return rejectWithValue(error as { code: number; message: string });
    }
  },
  {
    condition: ({ projectId, environmentId, reload }, { getState }) => {
      if (reload) return true;
      const state = getState();
      const existing =
        state.deployment?.images?.data?.[projectId]?.[environmentId];
      return !existing;
    }
  }
);
